/** @file The idle gizmo of a transform tool for the current selection. */
import { gizmoHandles } from '@pose2d/editor-geometry/gizmoHandles';
import type { GizmoTool } from '@pose2d/editor-geometry/types';
import type { GizmoDrawing, ToolContext } from '../../panels/viewport/viewportTypes';
import { gizmoFrame } from './gizmoFrame';
import { topSelected } from './topSelected';

/** null with no transformable selection. */
export function transformIdle(ctx: ToolContext, tool: GizmoTool): GizmoDrawing | null {
  const bones = topSelected(ctx, ctx.selection.bones);
  return bones.length === 0 ? null : { handles: gizmoHandles(tool, gizmoFrame(ctx, bones, tool)), active: null, points: [], lines: [] };
}
